module.exports = __webpack_public_path__ + "img/stoofvlees_chimay.66625140.jpg";